import Hero from '../components/Hero';
import About from '../components/About';
import Projects from '../components/Projects';
import Skills from '../components/Skills';
import CTA from '../components/CTA';
import usePageMeta from '../hooks/usePageMeta';

export default function HomePage() {
  usePageMeta('Lino | Developer', 'Lino – Python Developer & Freelancer aus Rostock. Web-Entwicklung, Automatisierung und IT-Dienstleistungen.');
  return (
    <>
      <Hero />
      <About />
      <Projects />
      <CTA />
      <Skills />
    </>
  );
}
